/* Sticky header — måler hvor mye av toppen som skal få lov til å scrolle bort.
   Se assets/bc-sticky-header.css for hvorfor sticky må ligge på wrapperen og
   ikke på <header> selv. */
(function () {
  var cleanup = null;

  function init() {
    if (cleanup) {
      cleanup();
      cleanup = null;
    }

    var header = document.querySelector('[data-bc-header]');
    if (!header) return;

    // Respekter seksjonsinnstillingen "Enable sticky header".
    if (header.getAttribute('data-bc-sticky') !== 'true') return;

    var wrap = header.closest('.shopify-section') || header.parentElement;
    if (!wrap) return;
    wrap.classList.add('bc-sticky-wrap');

    // Banneret ligger utenfor <header>, men inne i samme seksjonswrapper.
    var banner = wrap.querySelector('.bc-hcp-banner');
    var topbar = wrap.querySelector('[data-bc-topbar]');

    var offset = 0;

    function measure() {
      // offsetHeight er uavhengig av scrollposisjon, så dette blir riktig selv
      // når headeren allerede står festet med negativ top.
      offset = (banner ? banner.offsetHeight : 0) + (topbar ? topbar.offsetHeight : 0);
      wrap.style.setProperty('--bc-sticky-offset', offset + 'px');
    }

    function syncStuck() {
      var stuck = window.scrollY > offset;
      header.classList.toggle('is-stuck', stuck);
    }

    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        syncStuck();
        ticking = false;
      });
    }

    function remeasure() {
      measure();
      syncStuck();
    }

    measure();
    syncStuck();

    window.addEventListener('scroll', onScroll, { passive: true });

    var observer = null;
    if ('ResizeObserver' in window) {
      // Topbaren roterer USP-tekster og banneret brytes over to linjer på smale
      // skjermer — begge kan endre høyde etter første måling.
      observer = new ResizeObserver(remeasure);
      if (banner) observer.observe(banner);
      if (topbar) observer.observe(topbar);
    } else {
      window.addEventListener('resize', remeasure, { passive: true });
    }

    cleanup = function () {
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', remeasure);
      if (observer) observer.disconnect();
    };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Temaeditoren bygger seksjonen på nytt, så referansene over blir foreldet.
  document.addEventListener('shopify:section:load', function (event) {
    if (event.detail && event.detail.sectionId && event.detail.sectionId.indexOf('header') === -1) return;
    init();
  });
})();
